import type { DashboardOverallResponse, DashboardPerScopeValueResponse, DashboardResult, DashboardScope, DashboardResultType, DashboardResultOrder } from '@api/domain/types';

export enum DashboardOverviewDateRange {
  SEVEN_DAYS = '7days',
  YESTERDAY = 'yesterday',
  THIS_WEEK = 'thisWeek',
  LAST_WEEK = 'lastWeek',
  CURRENT_MONTH = 'currentMonth',
  PREVIOUS_MONTH = 'previousMonth',
  CURRENT_YEAR = 'currentYear',
  PREVIOUS_YEAR = 'previousYear',
  CUSTOM = 'custom',
}

export interface DashboardSectionState<TData> {
  data: TData | null;
  loading: boolean;
  error: string | null;
}

export interface DashboardDateRangeSelection {
  dateRange: DashboardOverviewDateRange;
  from: string;
  to: string;
}

export interface DashboardPerScopeValueListState {
  items: DashboardResult[];
  pageNumber: number;
  totalCount: number | null;
  hasMore: boolean;
  loading: boolean;
  error: string | null;
}

export interface DashboardState {
  dateRangeSelection: DashboardDateRangeSelection;
  scope: DashboardScope;
  resultType: DashboardResultType;
  listOrderBy: DashboardResultOrder;
  overall: DashboardSectionState<DashboardOverallResponse>;
  perScopeValueWorst: DashboardSectionState<DashboardPerScopeValueResponse>;
  perScopeValueBest: DashboardSectionState<DashboardPerScopeValueResponse>;
  perScopeValueList: DashboardPerScopeValueListState;
}
